"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var reducer_1 = __importStar(require("./addressValidationPopup/reducer"));
var reducer_2 = __importStar(require("./address/reducer"));
var reducer_3 = __importStar(require("./contact/reducer"));
var reducer_4 = __importStar(require("./payment/reducer"));
var reducer_5 = __importDefault(require("./shippingMethods/reducer"));
var addresses_1 = require("../../config/addresses");
var actions_1 = require("./actions");
var actions_2 = require("../utils/actions");
exports.initialState = (_a = {
        signUpForNewsletter: false,
        isPurchaseLoading: false,
        generalError: null
    },
    _a[addresses_1.CheckoutStoreAddresses.Billing] = (0, reducer_2.getInitialState)(addresses_1.CheckoutStoreAddresses.Billing),
    _a[addresses_1.CheckoutStoreAddresses.Shipping] = (0, reducer_2.getInitialState)(addresses_1.CheckoutStoreAddresses.Shipping),
    _a.contact = reducer_3.initialState,
    _a.payment = reducer_4.initialState,
    _a.shippingMethods = null,
    _a.addressValidationPopup = reducer_1.initialState,
    _a);
var setSignUpForNewsletter = function (action) {
    var value = action.payload.value;
    return value;
};
var setIsPurchaseLoading = function (action) {
    var isLoading = action.payload.isLoading;
    return isLoading;
};
var setGeneralError = function (action) {
    var error = action.payload.error;
    return error;
};
var checkoutReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = exports.initialState; }
    var signUpForNewsletter = state.signUpForNewsletter;
    var isPurchaseLoading = state.isPurchaseLoading;
    var generalError = state.generalError;
    if ((0, actions_2.isType)(action, actions_1.setSignUpForNewsletterAction)) {
        signUpForNewsletter = setSignUpForNewsletter(action);
    }
    else if ((0, actions_2.isType)(action, actions_1.setIsPurchaseLoadingAction)) {
        isPurchaseLoading = setIsPurchaseLoading(action);
    }
    else if ((0, actions_2.isType)(action, actions_1.setGeneralErrorAction)) {
        generalError = setGeneralError(action);
    }
    return __assign(__assign({}, state), (_a = { signUpForNewsletter: signUpForNewsletter, isPurchaseLoading: isPurchaseLoading, generalError: generalError }, _a[addresses_1.CheckoutStoreAddresses.Billing] = (0, reducer_2.default)(addresses_1.CheckoutStoreAddresses.Billing, state[addresses_1.CheckoutStoreAddresses.Billing], action), _a[addresses_1.CheckoutStoreAddresses.Shipping] = (0, reducer_2.default)(addresses_1.CheckoutStoreAddresses.Shipping, state[addresses_1.CheckoutStoreAddresses.Shipping], action), _a.contact = (0, reducer_3.default)(state.contact, action), _a.payment = (0, reducer_4.default)(state.payment, action), _a.shippingMethods = (0, reducer_5.default)(state.shippingMethods, action), _a.addressValidationPopup = (0, reducer_1.default)(state.addressValidationPopup, action), _a));
};
exports.default = checkoutReducer;
